import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EColors, EFonts, EHovers } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconName: IconName;
    text: string;
    darkText?: boolean;
    onClick?: () => void;
    className?: string;
}

export const BottomButton = (props: Props): JSX.Element => {
    return (
        <S_BottomButton
            className={props.className}
            onClick={props.onClick}
            $darkText={props.darkText}
        >
            {props.iconName && <S_Icon icon={['fal', props.iconName]} $darkText={props.darkText} />}
            <S_Text $darkText={props.darkText}>{props.text}</S_Text>
        </S_BottomButton>
    );
};

const S_BottomButton = styled.div<{ $darkText: boolean }>`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    user-select: none;
    ${(props) => {
        if (props.$darkText) {
            return css`
                &:hover {
                    box-shadow: unset;
                    background-color: #f4f4f4;
                }
            `;
        } else {
            return css`
                &:hover {
                    box-shadow: ${EHovers.LIGHT1};
                }
            `;
        }
    }}
`;

const S_Icon = styled(FontAwesomeIcon)<{ $darkText: boolean }>`
    font-size: 15px;
    margin: 0 0 13px 0;
    ${(props) => {
        if (props.$darkText) {
            return css`
                color: ${EColors.DARK};
            `;
        } else {
            return css`
                color: ${EColors.WHITE};
            `;
        }
    }}
`;

const S_Text = styled.div<{ $darkText: boolean }>`
    font-size: 12px;
    ${(props) => {
        if (props.$darkText) {
            return css`
                color: ${EColors.DARK};
            `;
        } else {
            return css`
                color: ${EColors.WHITE};
            `;
        }
    }}
    @media only screen and (min-width: 1260px) {
        font-family: ${EFonts.Medium};
    }
`;
